export enum UserEditPermissionLevel {
  None = "none",
  View = "view",
  EditPermissions = "edit_permissions",
  EditDetails = "edit_details",
}



// WEBPACK FOOTER //
// ./src/app/admin/users/user-management-models/user-privilege-edit-type.enum.ts